var lx = lx || {};
lx.pref = lx.pref || {};
var vVal = [];

lx.pref = {
    get: function (pPrefCode, pCallback) {				
		apex.server.process("getPrefValue", {
            x01: pPrefCode
		}, {
			dataType: "text",
			success: function (d) {
				pCallback(d);
			}
		});
	},
    getJSON: function (pPrefCode, pCallback) {
		var ret = '';
		for (i = 0; i < vVal.values.length; i++) {
			if (vVal.values[i].code == pPrefCode) {
				ret = vVal.values[i].val;
				pCallback(vVal.values[i].val);
			}
		}
		return ret;
	},
    getList: function (pPrefCode, pCallback) {				
		apex.server.process("getPrefValues", {
            f01: pPrefCode
		}, {
			dataType: "json",
			success: function (d) {
				vVal = d;
				pCallback(d);
			}
		});
	},
    getRpt: function (pRptType, pRptCode, pPrefCode, pCallback) {				
		apex.server.process("getPrefValueRpt", {
            x01: pRptType,
            x02: pRptCode,
            x03: pPrefCode
		}, {
			dataType: "text",
			success: function (d) {
				//alert(d);
				pCallback(d);
			}
		});
	},
    set: function (pPrefCode, pValue, pAll, pEtyId, pRecId) {
		var lValue = pValue;
		if ($("input[name='" + pPrefCode + "'][type='checkbox']").length > 0) {
			lValue = lx.util.getCheckedValuesByName(pPrefCode);
		}
		apex.server.process("setPrefValue", {
            x01: lValue,
            x02: pPrefCode,
            x03: pEtyId,
            x04: pRecId,
            x05: pAll
		}, {
			dataType: "text"
		});
	},
    setById: function (pId, pValue) {
		apex.server.process("setPrefValueById", {
            x01: pId,
            x02: pValue
		}, {
			dataType: "text"
		});
	},
	reset: function (p_pref_code, pId, pDatatype, p_ety_id, p_record_id, p_confirm) {
		var pIdValue = document.getElementById(pId).value;
		var pCheckDateFormat = lx.util.checkDateFormat(pIdValue, 'dd.mm.yyyy');
		if (pDatatype == 'D') {
			if (lx.util.checkDateFormat(pIdValue, 'dd.mm.yyyy')) {
				var r = confirm(apex.lang.getMessage("ARE_YOU_SURE"));
				if (r == true) {
					lx.pref.set(p_pref_code, pIdValue);
					$x(p_pref_code + "_TEXT").value = pIdValue;
				}
			} else {
				alert(apex.lang.getMessage("INVALID_DATE_FORMAT"));
			}
		}
		if (pDatatype == 'N') {
			if (isNaN(pIdValue)) {
				alert(apex.lang.getMessage("INVALID_NUMBER_FORMAT"));
			} else {
				if (p_confirm == 'N') {
					lx.pref.set(p_pref_code, pIdValue);
					$x(p_pref_code + "_TEXT").value = pIdValue;
				}
				else {
					var r = confirm(apex.lang.getMessage("ARE_YOU_SURE"));
					if (r == true) {
						lx.pref.set(p_pref_code, pIdValue);
						$x(p_pref_code + "_TEXT").value = pIdValue;
					}
				}
			}
		}
		if (pDatatype == 'S') {
			var r = confirm(apex.lang.getMessage("ARE_YOU_SURE"));
			if (r == true) {
				if (lxnvl(p_ety_id, 'Y') == 'Y') {
					lx.pref.set(p_pref_code, pIdValue);
				}
				else {
					lx.pref.set(p_pref_code, pIdValue, '', p_ety_id, p_record_id);
				};
				$x(p_pref_code + "_TEXT").value = pIdValue;
			}
		}
	},
	toggleCbx: function (pRegion, pCheck) {
		/*$('#' + pRegion + ' input[type="checkbox"]:checked').each(function() {
		  alert(this.id+"="+pCheck)
		});*/
		if (pCheck == 'Y') {
			$('#' + pRegion + ' input:checkbox:not(:checked)').each(function () {
				//alert("Not Checked Id: " + $(this).attr("id") + " Value: " + $(this).val());
				$(this).prop("checked", true);
				lx.pref.set(this.id, pCheck);
			});
		}
		if (pCheck == 'N') {
			$('#' + pRegion + ' input:checkbox:checked').each(function () {
				//alert("Checked Id: " + $(this).attr("id") + " Value: " + $(this).val());
				$(this).prop("checked", false);
				lx.pref.set(this.id, pCheck);
			});
		}
		/*$('#' + pRegion + ' input[type="checkbox"]').attr('checked', function () {
			if (pCheck == 'Y') {
				//alert(this.id+"="+pCheck);
				lx.pref.set(this.id, pCheck, 'Y');
				return true;
			} else {
				//alert(this.id+"="+pCheck);
				lx.pref.set(this.id, pCheck, 'Y');
				return false;
			}
		});*/
	},
	popupClear: function (pPrefCode, pThis) {
		//alert('popupClear'); 
		//$(pThis).siblings("span").find('input').val("");
		//alert($(pThis).siblings('input[type="hidden"]').val()); 
		$(pThis).siblings("input").val("");
		prefs_add_class(pPrefCode,"popup");
		//setPrefValue(pPrefCode, "");
	}
};

// TODO cleanup after we ditch the old app
var getPrefValue = lx.pref.get;
var setPrefValue = lx.pref.set;
var resetPrefValue = lx.pref.reset;
var togglePrefCheckBoxes = lx.pref.toggleCbx;
var prefPopupClear = lx.pref.popupClear;